// extracted by mini-css-extract-plugin
export default {"price":"PriceLabel_price__kf178","label":"PriceLabel_label__Tp5Vm"};